import React from 'react'
import { Link, useNavigate } from 'react-router-dom'

import { Form, Input, Button, Checkbox, Divider, Select } from 'antd'
import {
  MailOutlined,
  LockOutlined,
  GoogleOutlined,
  UserOutlined,
  MobileOutlined,
  CodeSandboxOutlined
} from '@ant-design/icons'
import { register } from '../../reducers/authReducer'

import { useDispatch } from 'react-redux'

import { PageContainer, FormContainer, FormWrapper, FormTitle } from './style'

const Registeration = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const onFinish = async (values) => {
    try {
      const result = await dispatch(register(values))
      if (result.success) {
        navigate('/login')
      }
    } catch (e) {
      console.log("can't register", e)
    }
  }

  return (
    <PageContainer>
      <FormContainer>
        <FormWrapper>
          <Form
            name="register"
            onFinish={onFinish}
            initialValues={{ remember: false }}
            scrollToFirstError
          >
            <FormTitle>Sign Up</FormTitle>
            <p>
              Have already Account ? <Link to="/login">Login</Link>
            </p>

            <Form.Item
              name="name"
              rules={[
                {
                  required: true,
                  message: 'Please enter your fullname'
                },
                {
                  min: 3,
                  message: 'Fullname must contain at least 3 characters'
                }
              ]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="Enter your fullname"
              />
            </Form.Item>

            <Form.Item
              name="username"
              rules={[
                {
                  required: true,
                  message: 'Please enter your username'
                },
                {
                  min: 3,
                  message: 'Username must contain at least 3 characters'
                }
              ]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="Enter your username"
              />
            </Form.Item>

            <Form.Item
              name="email"
              rules={[
                {
                  required: true,
                  message: 'Please enter your email'
                },
                {
                  pattern: /^[a-zA-Z0-9._%+-]+@spanidea\.com$/,
                  message: 'Please login with registered spanidea email'
                }
              ]}
            >
              <Input prefix={<MailOutlined />} placeholder="Enter your email" />
            </Form.Item>

            <Form.Item
              name="mobile"
              rules={[
                {
                  required: true,
                  message: 'Please enter your mobile'
                },
                {
                  pattern: /^[0-9]{10}$/,
                  message: 'Mobile number must be 10 digits'
                }
              ]}
            >
              <Input
                prefix={<MobileOutlined />}
                placeholder="Enter your mobile"
                maxLength={10}
                onKeyPress={(e) => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault()
                  }
                }}
              />
            </Form.Item>

            <Form.Item>
              <Button block type="primary" htmlType="submit">
                Sign Up
              </Button>
            </Form.Item>
          </Form>
        </FormWrapper>
      </FormContainer>
    </PageContainer>
  )
}
export default Registeration
